// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCheckMark: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7"><path fill="currentColor" d="M5.69318274,9.86253779 L10.8681773,4.46499381 C11.0439066,4.28168998 11.0439066,3.98451505 10.8681773,3.80122913 L10.2317957,3.13746444 C10.0560664,2.95417852 9.77112637,2.95417852 9.59539704,3.13746444 L5.37499197,7.53935245 L3.40458154,5.4842118 C3.22885221,5.30090797 2.94391217,5.30090797 2.76818283,5.4842118 L2.13180129,6.14797648 C1.95607196,6.33128031 1.95607196,6.62845524 2.13180129,6.81174117 L5.0568012,9.86251989 C5.23251336,10.0458237 5.51743624,10.0458237 5.69318274,9.86253779 Z" transform="translate(-2 -3)"/></svg>
    );
};

export default React.memo(IconCheckMark);
